<template>
  <div style="margin-top: 10px;">
    <el-row>
      <el-col :span="20">
        <div  style="float: left">
        <el-button
          style="margin-bottom: 10px"
          type="primary"
          icon="el-icon-plus"
          @click="openEditZoneDialog(true)"
          >添加分区</el-button
        >
      </div>

        <div style="margin-left: 10px; float: left">
          <div>
            <span style="font-size: 0.8rem"
              ><i
                class="el-icon-round"
                style="
                  background-color: rgb(73, 243, 73);
                  margin-right: 3px;
                  border: 1px solid rgb(27, 4, 14);
                "
              ></i
              >健康分区数：{{ zoneData.online }}</span
            >
          </div>
          <div style="margin-top: 2px">
            <span style="font-size: 0.8rem"
              ><i
                class="el-icon-round"
                style="
                  background-color: rgb(255, 65, 65);
                  margin-right: 3px;
                  border: 1px solid rgb(27, 4, 14);
                "
              ></i
              >异常分区数：{{ zoneData.offline }}</span
            >
          </div>
        </div>
        <!-- 自动开服配置 -->
        <div
          v-if="this.systemConfig.zoneAutoOpenConditions.length != 0"
          disabled
          style="
            margin-left: 100px;
            float: left;
            font-size: 0.8rem;
            border: 1px solid grey;
            border-radius: 10px;
            padding: 8px;
          "
        >
          <div style="font-size: 0.9rem; font-weight: bold">
            自动开服条件（仅需满足其一）：
          </div>
          <div
            v-for="item of this.systemConfig.zoneAutoOpenConditions"
            :key="item.seq"
          >
            - {{ getNameOfZoneAutoCondition(item.key) }} ≥ {{ item.value }}
          </div>
        </div>
        <div></div>
      </el-col>
    </el-row>

    <el-tabs v-model="tabValue" @tab-click="switchTabs">
      <el-tab-pane label="分区状态" name="zoneState">
        <ZoneStateListPage v-if="tabValue == 'zoneState'"></ZoneStateListPage>
      </el-tab-pane>
      <el-tab-pane label="分区列表" name="zoneList">
        <el-table :data="zoneList" border size="small" style="width: 1271px">
          <el-table-column prop="id" label="ID" align="center" width="70">
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column label="自动解除隐藏" align="center" width="130">
            <template scope="scope">
              <span>{{ ms2ymdhm(scope.row.autoVisibleAfter) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minVersion" align="center" width="100">
            <template slot="header">
              <span>游戏最低版本</span>
              <div>
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">低于该版本将看不到当前分区</div>
                  <span
                    ><i class="el-icon-question" style="font-size: 1.2em"></i
                  ></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="对外地址（http）"
            align="center"
            width="300"
          ></el-table-column>
          <el-table-column
            prop="internalAddress"
            label="对内地址（grpc）"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template scope="scope">
              <span v-if="scope.row.status == 0" class="zone-status-tag zone-status-tag-offline">隐藏</span>
              <span v-else-if="scope.row.status == 1" class="zone-status-tag zone-status-tag-maintained">维护</span>
              <span v-else-if="scope.row.status == 2" class="zone-status-tag zone-status-tag-idle">流畅</span>
              <span v-else-if="scope.row.status == 3" class="zone-status-tag zone-status-tag-full">爆满</span>
            </template>
          </el-table-column>
          <el-table-column prop="isHealth" sortable label="健康" align="center" width="70">
            <template slot="header">
              <span>健康</span>
              <!-- <div style="margin-top: 5px;float: left;" >
                    <div style="margin-left: 0px; float: left;">
                      <span style="font-size: 0.8rem;"><i class="el-icon-round" style="background-color: rgb(73, 243, 73); margin-right: 3px;border: 1px solid rgb(27, 4, 14);"></i>{{zoneData.online }}</span>
                    </div >
                    <div style="margin-left: 10px; float: left;">
                      <span style="font-size: 0.8rem;"><i class="el-icon-round" style="background-color: rgb(255, 65, 65); margin-right: 3px;border: 1px solid rgb(27, 4, 14);"></i>{{zoneData.offline}}</span>
                    </div>          
                  </div> -->
            </template>
            <template scope="scope">
              <span v-if="scope.row.isHealth">
                <i class="el-icon-round" style="
                    background-color: rgb(73, 243, 73);
                    margin-right: 3px;
                    border: 1px solid rgb(27, 4, 14);
                  "></i>
              </span>
              <span v-else>
                <i class="el-icon-round" style="
                    background-color: rgb(255, 65, 65);
                    margin-right: 3px;
                    border: 1px solid rgb(27, 4, 14);
                  "></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template scope="scope">
              <span class="link-button" @click="deleteZone(scope.row.id, scope.row.name)">删除</span>
              <span class="link-button" @click="openEditZoneDialog(true, scope.row)">复制</span>
              <span class="link-button" @click="openEditZoneDialog(false, scope.row)">修改</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="自动开服条件" name="zoneAutoOpenConfig">
        <ZoneAutoOpenConfigListPage
          @systemConfigChange="systemConfigChange"
          v-if="tabValue == 'zoneAutoOpenConfig'"
        ></ZoneAutoOpenConfigListPage>
      </el-tab-pane>
    </el-tabs>
    <!-- “编辑分区”对话框 -->
    <EditZoneDialog
      v-if="shouldEditZoneDialogVisible"
      @close="onEditZoneDialogClosed()"
      :value="valueForEditZoneDialog"
    >
    </EditZoneDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";
import EditZoneDialog from "./EditZoneDialog";
import ZoneAutoOpenConfigListPage from "./tab-pages/ZoneAutoOpenConfigListPage";
import ZoneStateListPage from "./tab-pages/ZoneStateListPage";

export default {
  data() {
    return {
      shouldEditZoneDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      valueForEditZoneDialog: null, // 要传递给“编辑分区”对话框的数据
      zoneList: [], // 邮件模板列表里展示的数据
      tabValue: "zoneState",
      sortData: {
        order: "",
        prop: "",
      },
      zoneData: {
        online: 0,
        offline: 0,
      },
      systemConfig: {
        zoneAutoOpenConditions: [],
      },
      availableConditions: [], // 可用的条件
    };
  },

  async created() {
    let orderBy = this.$route.query.orderBy;
    if (orderBy != null) {
      let arr = orderBy.split(",");
      let prop = this.$route.query.prop;
      this.sortData.order = arr[1];
      this.sortData.prop = arr[0];
    } else {
      this.sortData.order = "";
      this.sortData.prop = "";
    }

    // 拉取分区集合
    this.loadZoneList();

    await this.loadAvailableConditionsOfZoneAutoOpen()
    // 拉取运营级别可查看的配置
    await this.loadSystemConfigForAdminRoleNormal();
  },

  components: {
    EditZoneDialog,
    ZoneAutoOpenConfigListPage,
    ZoneStateListPage,
  },

  methods: {
    /**
     * 切换tab
     */
    async switchTabs(tab, event) {
      switch (tab.name) {
        case "zoneList": {
          this.loadZoneList();
          break;
        }
      }
    },
    /**
     * 查询分区集合
     */
    async loadZoneList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/zone/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.zones || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.zoneList = listInResponse;

      this.zoneData.online = 0;
      this.zoneData.offline = 0;
      for (let i = 0; i < this.zoneList.length; i++) {
        let item = this.zoneList[i];
        item.isHealth ? this.zoneData.online++ : this.zoneData.offline++;
      }
    },

    /**
     * 删除一个分区
     * @param {*} id
     * @param {*} name
     */
    async deleteZone(id, name) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除分区“${name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/zone/delete`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.zoneList.length; i++) {
          if (this.zoneList[i].id == id) {
            this.zoneList.splice(i, 1);
          }
        }
      } catch (e) {}
    },

    /**
     * 打开“编辑分区”对话框
     */
    async openEditZoneDialog(isCreate, oldData) {
      this.shouldEditZoneDialogVisible = true;
      this.valueForEditZoneDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “编辑分区”对话框关闭了
     */
    async onEditZoneDialogClosed() {
      this.shouldEditZoneDialogVisible = false;

      // 重新拉取分区集合
      return this.loadZoneList();
    },

    // 改变排序规则
    changeSort(e) {
      console.log(" this.$router:", this.$router);
      let orderBy = null;
      if (e.order != null) {
        orderBy = e.prop + "," + e.order;
      }

      this.$router.replace({
        orderBy: "",
        query: {
          orderBy: orderBy,
        },
      });
      /**  兼容性好*/
      window.location.reload();
    },

    /**
     * 加载运营级别能够查看的系统设置
     */
    async loadSystemConfigForAdminRoleNormal() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/systemConfig/getForAdminRoleNormal`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      this.systemConfig = resData.data || {};
    },
    /**
     * 加载可使用的自动开新区条件
     */
    async loadAvailableConditionsOfZoneAutoOpen() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/systemConfig/availableConditionsOfZoneAutoOpen`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      this.availableConditions = resData.data.availableConditions || [];
    },
    systemConfigChange(newValue) {
      this.systemConfig = newValue;
    },
    getNameOfZoneAutoCondition(key) {
      for (let i = 0; i < this.availableConditions.length; i++) {
        if (key == this.availableConditions[i].value) {
          return this.availableConditions[i].label;
        }
      }
      return key;
    },

    ms2day(ts) {
      return util.ms2day(ts);
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>


<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>

<!-- <style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style> -->